import CssBaseline from '@mui/material/CssBaseline';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './config';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';
import theme from './styles/theme';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
